import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import "../../components/DialogBoxCustom.css";
import useApiPost from "../hooks/postData";
import toast from "react-hot-toast";
import Loader from "../../assets/Loader.gif";

function CategoryFormDialog({ open, handleClose, onSaved, editingCategory }) {
  const { postData, loading } = useApiPost();

  const [name, setName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (open) {
      if (editingCategory) {
        setName(editingCategory.name || "");
        setSortOrder(
          editingCategory.sort_order !== undefined && editingCategory.sort_order !== null
            ? String(editingCategory.sort_order)
            : ""
        );
        setIsActive(!!editingCategory.is_active);
      } else {
        setName("");
        setSortOrder("");
        setIsActive(true);
      }
    }
  }, [open, editingCategory]);

  const handleSubmit = async () => {
    if (!name.trim()) {
      toast.error("Please enter a category name");
      return;
    }

    const payload = {
      name: name.trim(),
      is_active: isActive ? 1 : 0,
    };
    if (sortOrder !== "") payload.sort_order = Number(sortOrder);

    try {
      let response;
      if (editingCategory) {
        response = await postData("/hashtag-category/edit", {
          id: editingCategory.id,
          ...payload,
        });
      } else {
        response = await postData("/hashtag-category/create", payload);
      }

      if (response?.response_code === "1") {
        toast.success(editingCategory ? "Category updated" : "Category added");
        onSaved();
      } else {
        toast.error(response?.message || "Something went wrong");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth className="p-0 hashtag-dialog">
      <DialogTitle className="flex justify-center text-base font-bold text-[#000000] font-poppins dark:bg-primary bg-[#FFFFFF] shadow-lg dark:text-darkText">
        {editingCategory ? "Edit Category" : "Add Category"}
      </DialogTitle>

      <button
        onClick={handleClose}
        className="absolute text-2xl text-gray-600 dark:text-white top-2 right-2"
      >
        ×
      </button>

      <DialogContent className="flex flex-col mx-5 dark:mx-0 dark:bg-primary">
        <h2 className="text-base font-poppins text-[#000000] pt-4 font-semibold dark:text-darkText">
          Category Name
        </h2>
        <input
          type="text"
          placeholder="e.g. Funny"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="border border-opacity-gradient rounded-lg dark:bg-transparent dark:border-[#1F1F1F] placeholder:text-tableDarkLarge dark:text-darkText text-[#000000] w-full py-3 my-1 px-4 placeholder:text-sm placeholder:text-[#0000004F] bg-white focus:outline-none focus:ring-1 focus:ring-header"
        />

        <h2 className="text-base font-poppins text-[#000000] pt-4 font-semibold dark:text-darkText">
          Sort Order (optional)
        </h2>
        <input
          type="number"
          placeholder="e.g. 1"
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
          className="border border-opacity-gradient rounded-lg dark:bg-transparent dark:border-[#1F1F1F] placeholder:text-tableDarkLarge dark:text-darkText text-[#000000] w-full py-3 my-1 px-4 placeholder:text-sm placeholder:text-[#0000004F] bg-white focus:outline-none focus:ring-1 focus:ring-header"
        />

        <label className="flex items-center gap-2 pt-4 text-sm font-poppins text-[#000000] dark:text-darkText">
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />
          Active (visible in app)
        </label>

        <div className="flex justify-center py-6">
          <button
            className="w-[250px] py-3 font-medium text-white rounded-xl bg-button-gradient"
            onClick={handleSubmit}
          >
            {loading ? (
              <div className="flex justify-center py-2">
                <img src={Loader} alt="loader" height={16} width={16} />
              </div>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CategoryFormDialog;